export const CREATE_CHECKOUT_SESSION_MUTATION = `
  mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) { 
    createCheckoutSession(input: $input) {
      url
      id
    }
  }
`;

export const CreateCheckoutSessionMutation = async (graphqlService, variables) => {
    try {
      const response = await graphqlService.mutateData(CREATE_CHECKOUT_SESSION_MUTATION, variables);
      return response;
    } catch (error) {
      console.error("Stripe Checkout Session Error:", error);
      throw error;
    }
  };